<template>
    <nav aria-label="Page navigation" v-show="source.last_page != 1">
        <ul class="pager">
            <li :class="{ disabled: source.current_page == 1 }">
                <a href="javascript:;" @click="nextPrev($event, parseInt(source.current_page)-1);" aria-label="Previous">
                    <span class="setapaginate" aria-hidden="true"> &larr; </span> Anterior
                </a>
            </li>
            <!-- <li v-for="page in pages" :class="{active: source.current_page == page}">
                <a href="#" @click="navigate($event, page)">
                        <span class="page-numbers current">{{page}}</span>
                </a>
            </li> -->
            <li class="idpagina"> Página {{ source.current_page }} de {{ source.last_page }}</li>
            <li :class="{ disabled: source.current_page == source.last_page }">
                <a href="javascript:;" @click="nextPrev($event, parseInt(source.current_page)+1);" aria-label="Next">
                    Proxima <span class="setapaginate" aria-hidden="true"> &rarr; </span>
                </a>
            </li>
        </ul>
    </nav>
</template>
<script>
    import { range } from 'lodash'

            export default{

                props: ['source'],

                data() {
                    return{
                        pages: []
                    }
                },

                methods: {
                    navigate(ev, page) {
                        ev.preventDefault()

                        this.$dispatch('navigate', page)

                        //console.log(this.source.current_page)
                    },
                    nextPrev(ev, page) {
                      
                        window.scroll(0,0);
                        
                        if (page == 0 || page == this.source.last_page + 1) {

                            return false;
                        }

                        this.navigate(ev, page);
                    }
                },

                watch: {
                    source() {

                        this.pages = range(1, this.source.last_page + 1);

                    }
                }
            }
</script>
<style scoped>

    .idpagina{
        display: inline-block;
        margin: 0 15px;
        font-size: 15px;
    }

    .setapaginate{
        font-size: 20px;
    }

    .pager li > a{
        border-radius: 3px !important; 
    }

</style>



// WEBPACK FOOTER //
// pagination.vue?16bf5ba0